import { View } from './View'
import { Flex } from './Flex'

export { Pressable } from './pressable'

export { View } from './View'

export { Text } from './Text'

export { Image } from './Image'

export { H1 } from './H1'

export { H2 } from './H2'

export { H3 } from './H3'

export { H4 } from './H4'

export { H5 } from './H5'

export { H6 } from './H6'

export { A } from './A'

export { P } from './P'

export { ScrollView } from './ScrollView'

export { TextInput } from './TextInput'

export { FlatList } from './FlatList'

export { ActivityIndicator } from './activity-indicator'

export { Flex } from './Flex'

export { Container } from './Container'

export { SafeAreaView } from './SafeAreaView'

export const Row = Flex

export const Box = View
